import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Mic2 } from "lucide-react";

export const ParticipantPicker = ({ users, selected, onToggle, testId = "participant-list" }) => (
  <div className="grid gap-3 sm:grid-cols-2 max-h-[360px] overflow-y-auto pr-1" data-testid={testId}>
    {users.map((u) => {
      const on = selected.includes(u.id);
      return (
        <label
          key={u.id}
          htmlFor={`pp-${u.id}`}
          className={`flex items-center gap-3 rounded-xl border p-4 cursor-pointer transition-colors ${
            on ? "border-brand-600 bg-brand-50/60" : "border-slate-200 hover:bg-slate-50"}`}
          data-testid={`participant-option-${u.id}`}
        >
          <Checkbox id={`pp-${u.id}`} checked={on} onCheckedChange={() => onToggle(u.id)} />
          <span className="grid place-items-center h-9 w-9 shrink-0 rounded-full grad-brand text-white text-[11px] font-semibold">
            {u.name.slice(0, 2).toUpperCase()}
          </span>
          <span className="min-w-0 flex-1">
            <span className="block truncate text-sm font-medium text-slate-800">{u.name}</span>
            <span className="block truncate text-xs text-slate-500">{u.role_label} · {u.division || "—"}</span>
          </span>
          {u.voice_enrolled && <Mic2 size={15} className="shrink-0 text-emerald-500" title="Voiceprint terdaftar" />}
        </label>
      );
    })}
  </div>
);
